<div class="content-wrapper p-0">
	<app-content-header [contentHeader]="contentHeader"></app-content-header>
	<div class="content-body">
		<section class="app-ecommerce-details">
			<div class="card">
				<div class="card-body">
					<form [formGroup]="addExpertForm" autocomplete="off">
						<div class="row">
							<div class="col-md-3">
								<div class="form-group">
									<label class="form-label" for="firstName">First Name</label>
									<span class="required-asterisk">*</span>
									<input formControlName="FirstName" type="text" name="firstName" id="firstName" class="form-control" placeholder="John" [ngClass]="{ 'is-invalid': submitted && getExpertDetails.FirstName.errors }" />
									<div *ngIf="submitted && getExpertDetails.FirstName.invalid" class="invalid-form">
										<div *ngIf="getExpertDetails.FirstName.errors.required">This field is required!</div>
									</div>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label class="form-label" for="lastName">Last Name</label>
									<span class="required-asterisk">*</span>
									<input formControlName="LastName" type="text" name="lastName" id="lastName" class="form-control" placeholder="Doe" [ngClass]="{ 'is-invalid': submitted && getExpertDetails.LastName.errors }"/>
									<div *ngIf="submitted && getExpertDetails.LastName.invalid" class="invalid-form">
										<div *ngIf="getExpertDetails.LastName.errors.required">This field is required!</div>
									</div>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label class="form-label" for="email">Email</label>
									<span class="required-asterisk">*</span>
									<input formControlName="Email" type="text" name="email" id="email" class="form-control" placeholder="john.doe@email.com" [ngClass]="{ 'is-invalid': submitted && getExpertDetails.Email.errors }" />
									<div *ngIf="submitted && getExpertDetails.Email.invalid" class="invalid-form">
										<div *ngIf="getExpertDetails.Email.errors.required">This field is required!</div>
									</div>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label class="form-label" for="mobile">Mobile</label>
									<!-- <span class="required-asterisk">*</span> -->
									<input formControlName="Mobile" type="text" name="mobile" id="mobile" class="form-control" placeholder="0000000000" 
											[ngClass]="{ 'is-invalid': submitted && getExpertDetails.Mobile.errors }" maxlength="15" minlength="10"
											/>
									<!-- [mask]="'^([1-9]\\d*|0)$'" <div *ngIf="submitted && getExpertDetails.Mobile.invalid" class="invalid-form">
										<div *ngIf="getExpertDetails.Mobile.errors.required">This field is required!</div>
									</div> -->
									<div *ngIf="submitted && getExpertDetails.Mobile.invalid" class="invalid-form">
										<div *ngIf="getExpertDetails.Mobile.invalid">Please enter valid mobile number!</div>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-3" *ngIf="!isEdit">
								<div class="form-group">
									<label for="password" class="form-label">Password<span class="required-asterisk">*</span></label>
									<div class="input-group input-group-merge form-password-toggle">
										<input formControlName="Password" [type]="passwordTextType ? 'text' : 'password'" name="password"
										class="form-control form-control-merge" id="password" 
										[ngClass]="{ 'is-invalid error': submitted && getExpertDetails.Password.errors }"
										placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;" minlength="6"
										pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" />
										<div class="input-group-append">
										<span class="input-group-text cursor-pointer"><i class="feather font-small-4" [ngClass]="{
												'icon-eye-off': passwordTextType,
												'icon-eye': !passwordTextType
											}" (click)="togglePasswordTextType()"></i></span>
										</div>
									</div>
									<sup>The password must contain minimum 8 characters with at least one number, one uppercase and one lowercase letter.</sup>
									<div *ngIf="submitted && getExpertDetails.Password.invalid" class="form-text text-danger invalid-form">
										<div *ngIf="getExpertDetails.Password.errors.required">This field is required!</div>
										<div *ngIf="getExpertDetails.Password.errors.pattern">The password must contain minimum 8 characters with at least one number, one uppercase and one lowercase letter.</div>
									</div>
								</div>
							</div>
							<div class="col-md-3" *ngIf="!isEdit">
								<div class="form-group">
									<label for="confirmPassword" class="form-label">Confirm Password<span class="required-asterisk">*</span></label>
									<div class="input-group input-group-merge form-password-toggle">
										<input formControlName="ConfirmPassword" [type]="passwordTextType ? 'text' : 'password'"
										name="confirm-password" id="confirm-password" class="form-control"
										[ngClass]="{ 'is-invalid error': submitted && getExpertDetails.ConfirmPassword.errors }"
										placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
										pattern="{{ getExpertDetails.Password.value }}" minlength="6" />
										<div class="input-group-append">
										<span class="input-group-text cursor-pointer"><i class="feather font-small-4" [ngClass]="{
												'icon-eye-off': passwordTextType,
												'icon-eye': !passwordTextType
											}" (click)="togglePasswordTextType()"></i></span>
										</div>
									</div>
									<div *ngIf="submitted && getExpertDetails.ConfirmPassword.invalid" class="form-text text-danger invalid-form">
										<div *ngIf="getExpertDetails.ConfirmPassword.errors.required">This field is required!</div>
										<div *ngIf="getExpertDetails.ConfirmPassword.errors.pattern">Password & Confirm Password does not match.</div>
									</div>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label class="form-label" for="userRole">User Role</label>
									<input formControlName="UserRole" type="text" name="UserRole" id="UserRole" class="form-control" readonly/>
								</div>
							</div>
							<div class="col-md-3">
								<label class="form-label" for="gender">Gender</label>
								<div class="demo-inline-spacing" style="margin-top: -15px;">
									<div class="custom-control custom-radio">
										<input type="radio" id="genderM"
											formControlName="gender" name="gender"
											class="custom-control-input" value="M" [ngClass]="{ 'is-invalid': submitted && !getExpertDetails.gender.valid }"/>
										<label class="custom-control-label"
											for="genderM">Male</label>
									</div>
									<div class="custom-control custom-radio">
										<input type="radio" id="genderF"
											formControlName="gender" name="gender"
											class="custom-control-input" value="F" [ngClass]="{ 'is-invalid': submitted && !getExpertDetails.gender.valid }"/>
										<label class="custom-control-label"
											for="genderF">Female</label>
									</div>
									<div class="custom-control custom-radio">
										<input type="radio" id="genderO"
											formControlName="gender" name="gender"
											class="custom-control-input" value="O" [ngClass]="{ 'is-invalid': submitted && !getExpertDetails.gender.valid }"/>
										<label class="custom-control-label"
											for="genderO">Other</label>
									</div>
									<span *ngIf="submitted && getExpertDetails.gender.invalid" class="invalid-form">
										<small class="form-text text-danger" *ngIf="getExpertDetails.gender.errors.required">This field is required!</small>
									</span>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label class="form-label" for="title">Title </label>
									<input formControlName="title" type="text" name="title" id="title" class="form-control"  placeholder="Title" [ngClass]="{ 'is-invalid': submitted && getExpertDetails.title.errors }"/>
									<!-- <div *ngIf="submitted && getExpertDetails.title.invalid" class="invalid-form">
										<div *ngIf="getExpertDetails.title.errors.required">This field is required!</div>
									</div> -->
								</div>
							</div>
							<div class="col-md-3">
								<label for="dateOfBirth">Date of Birth</label>
								<div class="input-group">
									<input class="form-control" placeholder="dd-mm-yyyy" name="dateOfBirth"
									[minDate]="{year: minDate.year, month: minDate.month, day:minDate.day}"
									[maxDate]="{year: maxDate.year, month: maxDate.month, day:maxDate.day}"	
									formControlName="dateOfBirth" ngbDatepicker #MinMaxDP="ngbDatepicker"
									[readonly]="true" />
									<div class="input-group-append">
										<button class="btn btn-outline-secondary feather icon-calendar"
											(click)="MinMaxDP.toggle();" type="button" rippleEffect></button>
									</div>
								</div>
								<!-- <span *ngIf="submitted && getExpertDetails.dateOfBirth.invalid" class="invalid-form">
									<small class="form-text text-danger" *ngIf="getExpertDetails.dateOfBirth.errors.required">This
										field is required!</small>
								</span> -->
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label class="form-label" for="designation">Designation </label>
									<input formControlName="designation" type="text" name="designation" 
									id="designation" class="form-control"  placeholder="Designation"
									/>
									<!-- <div *ngIf="submitted && getExpertDetails.designation.invalid" class="invalid-form">
										<div *ngIf="getExpertDetails.designation.errors.required">This field is required!</div>
									</div> -->
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label for="identityProof" class="form-label">Identity Proof
										</label>
									<ng-select [items]="identityProofType" bindLabel="identityProofTypeName" bindValue="identityProofTypeID" formControlName="identityProof" 
										[closeOnSelect]="true" placeholder="Select Identity Proof" 
										>
									</ng-select> 
									<!-- <div *ngIf="submitted && getExpertDetails.identityProof.invalid" class="invalid-form">
										<div *ngIf="getExpertDetails.identityProof.errors.required">This field is required!</div>
									</div> -->
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-3">
								<div class="form-group">
									<label for="subjectType" class="form-label">Category<span class="required-asterisk">*</span></label>
									<ng-select [items]="subjectType" bindLabel="subjectTypeName" bindValue="subjectTypeID" formControlName="Subject" multiple="true"
										[closeOnSelect]="true" placeholder="Select Category" 
										(change)="subjectChange($event,false)" 
										[class.error]="!getExpertDetails.Subject.valid && submitted"
										>
									</ng-select> 
									<div *ngIf="submitted && getExpertDetails.Subject.invalid" class="invalid-form">
										<div *ngIf="getExpertDetails.Subject.errors.required">This field is required!</div>
									</div>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label for="department" class="form-label">Department<span class="required-asterisk">*</span></label>
									<ng-select [items]="department" bindLabel="departmentName" bindValue="departmentID" formControlName="department" multiple="true"
										[closeOnSelect]="true" placeholder="Select Department" 
										(change)="departmentChange($event,false)" 
										[class.error]="!getExpertDetails.department.valid && submitted">
									</ng-select> 
									<div *ngIf="submitted && getExpertDetails.department.invalid" class="invalid-form">
										<div *ngIf="getExpertDetails.department.errors.required">This field is required!</div>
									</div>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label for="CategoryType" class="form-label">Area of Expertise<span class="required-asterisk">*</span></label>
									<ng-select [items]="CategoryType" bindLabel="categoryTypeName" bindValue="categoryTypeID" formControlName="Category" multiple="true"
										[closeOnSelect]="true" placeholder="Area of Expertise" 
										[class.error]="!getExpertDetails.Category.valid && submitted">
									</ng-select> 
									<div *ngIf="submitted && getExpertDetails.Category.invalid" class="invalid-form">
										<div *ngIf="getExpertDetails.Category.errors.required">This field is required!</div>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-3">
								<div class="form-group">
									<label for="institute " class="form-label">Institute</label>
									<input formControlName="institute" type="text" name="institute" id="institute" class="form-control" 
									 placeholder="Institute"/>
									<!-- <div *ngIf="submitted && getExpertDetails.institute.invalid" class="invalid-form">
										<div *ngIf="getExpertDetails.institute.errors.required">This field is required!</div>
									</div> -->
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label for="instituteAddress " class="form-label">Institute Address</label>
									<textarea type="text" type="text" name="instituteAddress" id="instituteAddress" placeholder="Institute Address" formControlName="instituteAddress" class="form-control"
									></textarea>
									<!-- <span *ngIf="submitted && getExpertDetails.instituteAddress.invalid" class="invalid-form">
										<small class="form-text text-danger" *ngIf="getExpertDetails.instituteAddress.errors.required">This
											field is required!</small>
									</span> -->
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label for="customerAddress " class="form-label">Expert Address</label>
									<textarea type="text" type="text" name="customerAddress" id="customerAddress" placeholder="Expert Address" formControlName="customerAddress" class="form-control"
										></textarea>
									<!-- <span *ngIf="submitted && getExpertDetails.customerAddress.invalid" class="invalid-form">
										<small class="form-text text-danger" *ngIf="getExpertDetails.customerAddress.errors.required">This
											field is required!</small>
										<small class="form-text text-danger" *ngIf="getExpertDetails.customerAddress.errors.pattern">This field contain atleast one alphanumerical value!</small>
									</span> -->
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label for="country" class="form-label">Country</label>
									<ng-select [items]="countryData" bindLabel="countryName" bindValue="countryID" formControlName="country" 
										[closeOnSelect]="true"  (clear)="countryChange(0);"
										(change)="countryChange($event.countryID)" placeholder="Select Country" 
										>
									</ng-select> 
									<!-- <div *ngIf="submitted && getExpertDetails.country.invalid" class="invalid-form">
										<div *ngIf="getExpertDetails.country.errors.required">This field is required!</div>
									</div> -->
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label for="state" class="form-label">State</label>
									<ng-select [items]="stateData" bindLabel="stateName" bindValue="stateID" formControlName="state" 
										[closeOnSelect]="true"  (clear)="stateChange(0);"
										(change)="stateChange($event.stateID)" placeholder="Select State"
										>
									</ng-select> 
									<!-- <div *ngIf="submitted && getExpertDetails.state.invalid" class="invalid-form">
										<div *ngIf="getExpertDetails.state.errors.required">This field is required!</div>
									</div> -->
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label for="city" class="form-label">City</label>
									<ng-select [items]="cityData" bindLabel="cityName" bindValue="cityID" formControlName="city" 
										[closeOnSelect]="true" placeholder="Select City" 
										>
									</ng-select> 
									<!-- <div *ngIf="submitted && getExpertDetails.city.invalid" class="invalid-form">
										<div *ngIf="getExpertDetails.city.errors.required">This field is required!</div>
									</div> -->
								</div>
							</div>
							<div class="col-md-3">
								<label for="pincode" class="form-label">Pincode</label>
								<input formControlName="pincode" type="text" name="pincode" 
								id="pincode" class="form-control" 
								[ngClass]="{ 'is-invalid': submitted && getExpertDetails.pincode.invalid }" 
								placeholder="Pincode" [mask]="'^([1-9]\\d*|0)$'" maxlength="6" minlength="6"
								/>
								<div *ngIf="submitted && getExpertDetails.pincode.invalid" class="invalid-form">
									<div class="form-text text-danger" >Please enter valid Pincode!</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-3">
								<label class="form-label" for="MOMdocument">Upload Profile</label>
								<br />
								<sup>Upload image of size upto 25MB</sup>
								<div class="custom-file">
									<input type="file" class="form-control custom-file-input" ng2FileSelect 
										id="file-upload-single" (click)="browsbuttonClick('profilePicture')" (change)="uploadProfilefileChange($event, 25)"
										formControlName="profileDoc"
										[ngClass]="{ 'is-invalid': submitted && !getExpertDetails.profileDoc.valid }" />
									<label class="custom-file-label" id="profileDoc"
										for="file-upload-single">{{getExpertDetails.profileDocName.value}}</label>
								</div>
								<span *ngIf="submitted && getExpertDetails.profileDoc.invalid" class="invalid-form">
									<small class="form-text text-danger" *ngIf="getExpertDetails.profileDoc.errors.required">This
										field is required!</small>
								</span>
							</div>
							<div class="col-md-3 pt-4" *ngIf="profileURL != '' ">
								<a href="{{profileURL}}"
									target="_blank"><i
										class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
										title="Download Document"></i></a>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12 text-right">
								<button class="btn btn-primary" tabindex="5"  (click)="onSubmit()" rippleEffect>Submit</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</section>
	</div>
</div>

